// Generated by ReScript, PLEASE EDIT WITH CARE


function formStatusValueToString(status) {
  switch (status) {
    case "Empty" :
      return "EMPTY";
    case "Filling" :
      return "FILLING";
    case "Complete" :
      return "COMPLETE";
  }
}

function formStatusValueFromString(str) {
  switch (str) {
    case "COMPLETE" :
      return "Complete";
    case "FILLING" :
      return "Filling";
    default:
      return "Empty";
  }
}

function eventToString(eventType) {
  switch (eventType) {
    case "PaymentMethodInfoCard" :
      return "PAYMENT_METHOD_INFO_CARD";
    case "PaymentMethodStatus" :
      return "PAYMENT_METHOD_STATUS";
    case "FormStatus" :
      return "FORM_STATUS";
    case "PaymentMethodInfoBillingAddress" :
      return "PAYMENT_METHOD_INFO_BILLING_ADDRESS";
    case "CvcStatus" :
      return "CVC_STATUS";
    case "Surcharge" :
      return "SURCHARGE";
    case "UnknownEvent" :
      return "UNKNOWN_EVENT";
  }
}

function eventFromString(str) {
  switch (str) {
    case "CVC_STATUS" :
      return "CvcStatus";
    case "FORM_STATUS" :
      return "FormStatus";
    case "PAYMENT_METHOD_INFO_BILLING_ADDRESS" :
      return "PaymentMethodInfoBillingAddress";
    case "PAYMENT_METHOD_INFO_CARD" :
      return "PaymentMethodInfoCard";
    case "PAYMENT_METHOD_STATUS" :
      return "PaymentMethodStatus";
    case "SURCHARGE" :
      return "Surcharge";
    default:
      return "UnknownEvent";
  }
}

export {
  formStatusValueToString,
  formStatusValueFromString,
  eventToString,
  eventFromString,
}
/* No side effect */
